import { connect } from 'react-redux';

import ListSolicitacoes from './listSolicitacoes';

export default connect()(ListSolicitacoes);
